<template>
  <!-- szkielet bootstrapowego modala, srodek wg EKRAN 6 referencji (cf-modal);
       stany (confirmModal / messageBox / changePasswModal / stepFail / thankYouModal)
       i obsluga bez zmian -->
  <div  class="modal fade" ref="modal-Fogot-Password" id="ForgotPasswordModal" tabindex="-1" >

    <!--=======================Sending email content=======================================-->
    <div v-if="confirmModal&&!changePasswModal&&!messageBox" class="modal-dialog modal-dialog-centered cf-modal-dialog">
      <div class="modal-content cf cf-modal">
        <div class="cf-modal__head">
          <div class="cf-stack" style="gap:6px">
            <h2 class="cf-h2" style="font-size:23px">Przypomnienie hasła</h2>
            <p class="cf-meta" style="margin:0">Wyślemy Ci link do ustawienia nowego hasła.</p>
          </div>
          <button type="button" class="cf-modal__close" data-bs-dismiss="modal" aria-label="Zamknij">×</button>
        </div>
        <form class="cf-modal__body" novalidate @submit.prevent="!$v.creds.email_creds.$invalid && change()">
          <div class="cf-field">
            <label class="cf-field__label" for="fp-email">E-mail</label>
            <input ref="input" id="fp-email" type="email" class="cf-input" autocomplete="username"
                   :data-error="$v.creds.email_creds.$invalid && $v.creds.email_creds.$dirty ? 'true' : null"
                   :data-valid="!$v.creds.email_creds.$invalid && $v.creds.email_creds.$dirty ? 'true' : null"
                   v-model="creds['email_creds']" @input="$v.creds.email_creds.$touch();">
            <span v-if="$v.creds.email_creds.$invalid && $v.creds.email_creds.$dirty" class="cf-field__error">Podaj poprawny adres e-mail.</span>
          </div>
          <button type="submit" class="cf-btn cf-btn--primary cf-btn--block"
                  :aria-disabled="$v.creds.email_creds.$invalid ? 'true' : 'false'">Wyślij link</button>
        </form>
      </div>
    </div>

    <!--=======================message box content=======================================-->
    <div v-else-if="!confirmModal&&!changePasswModal&&messageBox" class="modal-dialog modal-dialog-centered cf-modal-dialog">
      <div class="modal-content cf cf-modal">
        <div class="cf-modal__head">
          <h2 class="cf-h2" style="font-size:23px">
            <template v-if="emailSend">Sprawdź pocztę</template>
            <template v-else-if="reject">Nie udało się</template>
            <template v-else-if="changedPassword">Hasło zmienione</template>
          </h2>
          <button type="button" class="cf-modal__close" @click="goBackToBeg" aria-label="Zamknij">×</button>
        </div>
        <div class="cf-modal__body">
          <p v-if="emailSend" class="cf-modal__msg">Wiadomość z linkiem potwierdzającym została wysłana na Twój adres e-mail.</p>
          <p v-else-if="reject" class="cf-modal__msg">Przepraszamy, zmiana hasła nie jest teraz możliwa. Spróbuj ponownie lub skontaktuj się z nami.</p>
          <p v-else-if="changedPassword" class="cf-modal__msg">Twoje hasło zostało zmienione. Możesz się zalogować.</p>
          <a class="cf-btn cf-btn--primary cf-btn--block" data-bs-dismiss="modal" @click="goBackToBeg">OK</a>
        </div>
      </div>
    </div>

    <!--=======================Changing password content=======================================-->
    <div v-else-if="!confirmModal&&changePasswModal&&!messageBox" class="modal-dialog modal-dialog-centered cf-modal-dialog">
      <div class="modal-content cf cf-modal">
        <div class="cf-modal__head">
          <div class="cf-stack" style="gap:6px">
            <h2 class="cf-h2" style="font-size:23px">Nowe hasło</h2>
            <p class="cf-meta" style="margin:0">Min. 6 znaków, wielka i mała litera oraz znak specjalny.</p>
          </div>
          <button type="button" class="cf-modal__close" @click="goBackToBeg" aria-label="Zamknij">×</button>
        </div>
        <form class="cf-modal__body" novalidate @submit.prevent="!$v.creds.passw.$invalid && changePassw()">
          <div class="cf-field">
            <label class="cf-field__label" for="fp-pass">Nowe hasło</label>
            <input ref="input" id="fp-pass" type="password" class="cf-input" autocomplete="new-password"
                   :data-error="$v.creds.passw.$invalid && $v.creds.passw.$dirty ? 'true' : null"
                   :data-valid="!$v.creds.passw.$invalid && $v.creds.passw.$dirty ? 'true' : null"
                   v-model="creds['passw']" @input="$v.creds.passw.$touch();">
            <span v-if="$v.creds.passw.$invalid && $v.creds.passw.$dirty" class="cf-field__error">Hasło musi mieć min. 6 znaków, wielką i małą literę oraz znak specjalny.</span>
          </div>
          <div class="cf-field">
            <label class="cf-field__label" for="fp-pass2">Powtórz hasło</label>
            <input id="fp-pass2" type="password" class="cf-input" autocomplete="new-password"
                   :data-error="$v.creds.passw_conf.$invalid && $v.creds.passw_conf.$dirty ? 'true' : null"
                   :data-valid="!$v.creds.passw_conf.$invalid && $v.creds.passw_conf.$dirty ? 'true' : null"
                   v-model="creds['passw_conf']" @input="$v.creds.passw_conf.$touch();">
            <span v-if="$v.creds.passw_conf.$invalid && $v.creds.passw_conf.$dirty" class="cf-field__error">Hasła nie są takie same.</span>
          </div>
          <button type="submit" class="cf-btn cf-btn--primary cf-btn--block"
                  :aria-disabled="$v.creds.passw.$invalid ? 'true' : 'false'">Zmień hasło</button>
        </form>
      </div>
    </div>

    <!--=======================step fail info=======================================-->
    <div v-else-if="stepFail" class="modal-dialog modal-dialog-centered cf-modal-dialog">
      <div class="modal-content cf cf-modal">
        <div class="cf-modal__head">
          <h2 class="cf-h2" style="font-size:23px">Zaloguj się</h2>
          <button type="button" class="cf-modal__close" aria-label="Zamknij" @click="goBackToBeg">×</button>
        </div>
        <div class="cf-modal__body">
          <p class="cf-modal__msg">Aby przejść dalej, zaloguj się na swoje konto.</p>
          <a class="cf-btn cf-btn--primary cf-btn--block" data-bs-dismiss="modal" @click="goBackToBeg">OK</a>
        </div>
      </div>
    </div>

    <!--=======================thank you info=======================================-->
    <div v-else-if="thankYouModal" class="modal-dialog modal-dialog-centered cf-modal-dialog">
      <div class="modal-content cf cf-modal">
        <div class="cf-modal__head">
          <h2 class="cf-h2" style="font-size:23px">Dziękujemy</h2>
          <button type="button" class="cf-modal__close" aria-label="Zamknij" @click="goBackToBeg">×</button>
        </div>
        <div class="cf-modal__body">
          <p class="cf-modal__msg">Dziękujemy za podpisanie umowy.</p>
          <a class="cf-btn cf-btn--primary cf-btn--block" data-bs-dismiss="modal" @click="goBackToBeg">OK</a>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import { required, minLength, between , sameAs, email} from 'vuelidate/lib/validators'

  export default {
    data(){
      return{
        //input value
        creds: {},
        //token ,,code="
        token:'',
        //email after decoding
        email_from_token:'',
        //modal
        modal:null,
        //client email
        email:'',
        stepFail:false,
        thankYouModal:false,
        //which modal should open
        //sending email content
        confirmModal:true,
        //changing password content
        changePasswModal:false,
        //message box content
        messageBox:false,
        //message box content
        //message after email is send
        emailSend:true,
        //message with reject
        reject:false,
        //changed password message
        changedPassword:false


      }
    },
    //====================
    //validate input value
    //====================
    validations(){

      return {
        creds: {

          passw: {
            required,
            minLength: minLength(6),
            passwordPolicy: this.passwordPolicy
          },

          passw_conf: {
            required,
            sameAsPassword: sameAs('passw'),
          },

          email_creds:{
            required,
            email: email
          }
        }
      }
    },

    //========================================================
    //Second step , sending token and client email to database
    //========================================================

    created(){
      this.listen('ForgotPasswordModal', (v) => {
        let decoded=''
        if(v!=="stepFail" && v!=="thankYouModal")
          decoded=eval(window.atob(unescape(encodeURIComponent( v ))));
        /*console.log(decoded[0]);
        console.log(decoded[1]);*/
        /* console.log(v)*/
        if(v==="stepFail"){
          this.changePasswModal = false;
          this.confirmModal = false;
          this.messageBox = false;
          this.stepFail = true;
          this.modal.show();
        }
        else if(v==="thankYouModal"){
          this.changePasswModal = false;
          this.confirmModal = false;
          this.messageBox = false;
          this.stepFail = false;
          this.thankYouModal=true;
          this.modal.show();
        }
        else {
          this.patch('client/password', {client_email: decoded[0], client_code: decoded[1]}).then(response => {
            if (!!response.data) {
              if (!(response.data.IS_ERROR | 0)) {
                /*console.log("token jest poprawny");*/
                this.email_from_token = decoded[0];
                this.token = decoded[1];
                this.changePasswModal = true;
                this.confirmModal = false;
                this.messageBox = false;
                this.modal.show();
              } else {
                /*console.log("token jest niepoprawny");*/
                this.confirmModal = false;
                this.changePasswModal = false;
                this.messageBox = true;
                this.emailSend = false;
                this.reject = true;
                this.changedPassword = false;
                this.modal.show();
              }
            }
          })
            .catch(error => {
              if (error.response) {
                this.confirmModal = false;
                this.changePasswModal = false;
                this.messageBox = true;
                this.emailSend = false;
                this.reject = true;
                this.changedPassword = false;
                this.modal.show();
              }
            });

        }
      });
    },
    mounted(){
      this.modal = new bootstrap.Modal(this.$refs['modal-Fogot-Password']);
    },
    methods:{

      //=======================
      //Close message box modal
      //=======================

      CloseMessageBox(){
        this.modal.hide();
        setTimeout(()=>{
          if(this.messageBox&&this.emailSend || this.stepFail){
            this.confirmModal = true;
            this.changePasswModal = false;
            this.messageBox=false;}
        }, 1000)

      },

      //======================================
      //First step , sending email to database
      //======================================

      change()
      {
        this.modal.hide()
        this.put('client/password', {client_email:this.creds.email_creds}).then(response => {
          /*console.log(response.data)*/
          if (!!response.data) {
            /*console.log(response.data.IS_ERROR)*/
            if ( !(response.data.IS_ERROR | 0)) {
              /*console.log('its ok email is error = 0')*/
            }
            /*else console.log("email jest niepoprawny")*/

          }
          /*else console.log("co tu jest grane")*/

        })
          .catch(error => {

          });



        setTimeout(() => {

          this.confirmModal = false;
          this.changePasswModal = false;
          this.messageBox=true;
          this.modal.show()
        }, 700)
      },

      //=============================================================
      //Third step, showing changing password content modal or reject
      //=============================================================

      changePassw() {
        /* console.log(this.email_from_token);
         console.log(this.token);
         console.log(this.passw);*/
        this.patch('client/password', {
          client_email: this.email_from_token,
          client_code: this.token,
          client_password: this.creds['passw']

        }).then(response => {
          /*console.log(response.data + " asdasdas");
            console.log(this.passw)*/
          if (!!response.data) {
            if (!(response.data.IS_ERROR | 0)) {
              /*console.log("token jest poprawny");*/
              this.confirmModal = false;
              this.changePasswModal = false;
              this.messageBox = true;
              this.emailSend = false;
              this.reject = false;
              this.changedPassword = true;
            } else {
              /*console.log("token jest niepoprawny");*/
              this.confirmModal = false;
              this.changePasswModal = false;
              this.messageBox = true;
              this.emailSend = false;
              this.reject = true;
              this.changedPassword = false;
            }
          }
        })
          .catch(error => {
            if (error.response) {
              this.confirmModal = false;
              this.changePasswModal = false;
              this.messageBox = true;
              this.emailSend = false;
              this.reject = true;
              this.changedPassword = false;
            }
          });

        this.$v.$reset();
      },
      //=========================

      goBackToBeg(){
        this.modal.hide();
        setTimeout(()=>{

          this.$v.$reset();
          this.creds.email_creds='';
          this.confirmModal=true;
          this.changePasswModal=false;
          this.messageBox=false;
          this.emailSend=true;
          this.reject=false;
          this.changedPassword=false;




        },1000)

      }
    },
    computed:{
      //====================
      //checking input value
      //====================
      invalidPassword() {
        return this.isDirty && !this.creds['passw']
      },

      invalidCreds() {
        return this.isDirty
      }
      //====================
    }
  }
</script>
<style scoped>
/* wyglad modala: cf-modal w src/assets/cf-theme.css */
</style>



// WEBPACK FOOTER //
// src/components/ForgotPasssword.vue